<template>
  <div class="my-3">
    <b-btn v-if="Subtotal > 0.00" class="font-weight-bold" block variant="warning" @click="showModal">
      Give Credit (Comp & Discount)
      <span v-if="$showApprove([3, 4, 5, 11, 12])">*</span>
    </b-btn>
    <approve-permission
      v-if="!CreateOrderMode"
      :orderId="orderId"
      :tab-no="order.TabNo"
      v-model="approveModal"
      action-type="GiveCredit"
      @acceptPermission="openWithAcceptPermission"
    />
    <Cmodal
      v-model="modal"
      cancel-label="Never mind"
      centered
      size="md"
      title="Give Credit (Comp & Discount)"
      :tag="false"
      confirm-label="Apply Credit"
      :progressing="loading"
      @show="show"
      @submit="addCredit"
    >
      <template>
        <b-input-group prepend="Credit Amount ($)">
          <b-input
            v-model="orderCredit"
            type="number"
            v-validate="'required|min_value:0|lessOrEqualThan:' + Subtotal.toFixed(2)"
            name="Credit Amount"
          />
        </b-input-group>
        <ul class="percent my-3 mb-5 px-0 d-flex flex-row justify-content-between">
          <li
            v-for="(item, index) in percents"
            :key="index"
            class="py-2"
            style="cursor:pointer"
            @click="calcCreditByPercent(item)"
          >
            <span v-if="!item">
              ZERO
            </span>
            <span v-else>
              {{ item + '%' }}
            </span>
          </li>
        </ul>
        <section>
          <div class="h4 mb-3">
            Reason for Credit:
          </div>
          <b-form-group v-slot="{ariaDescribedby}">
            <b-form-radio-group
              size="lg"
              id="refundReasons"
              v-model="Reason"
              :aria-describedby="ariaDescribedby"
              name="Reason"
              v-validate="'required'"
            >
              <b-form-radio style="margin-bottom: 20px" value="Promotions">Promotions</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Guest Relations">Guest Relations</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Staff Meals">Staff Meals</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Owner Meals">Owner Meals</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Cash (No-Penny) Rounding">Cash (No-Penny) Rounding</b-form-radio>
              <b-form-radio style="margin-bottom: 20px" value="Other">Other</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </section>
        <b-alert :show="errors.any()" variant="danger" class="px-4">
          <ul class="m-0 px-1" style="list-style: none">
            <li v-for="err in errors.all()" :key="err">{{ err }}</li>
            <li v-if="orderCredit == Subtotal">Please cancel tab instead of giving full credit.</li>
          </ul>
        </b-alert>
      </template>
    </Cmodal>
  </div>
</template>

<script>
import NumericInput from '@/components/shared/NumericInput'
import Cmodal from '../shared/Cmodal'
import validation from '../../mixins/validation'
import ApprovePermission from '../shared/approvePermission'
export default {
  name: 'UpdateCredit',
  components: {ApprovePermission, NumericInput, Cmodal},
  mixins: [validation],
  props: {
    Subtotal: {
      required: true
    },
    Credit: {
      required: true
    },
    loadingBtn: {
      required: true
    },
    orderId: {
      required: false
    },
    order: {required:false, type: Object, default: () => ({})},
    TabNo: {type: [String, Number], default: ''},
    CreateOrderMode:{type:Boolean,default:false}
  },
  data() {
    return {
      enableCredit: false,
      orderCredit: this.Credit,
      modalFooterId: false,
      modal: false,
      percents: [0, 10, 30, 50, 70, 100],
      loading: false,
      reasonItems: [
        {text: 'Promotions', value: 'Promotions'},
        {text: 'Guest Relations', value: 'Guest Relations'},
        {text: 'Staff Meals', value: 'Staff Meals'},
        {text: 'Owner Meals', value: 'Owner Meals'},
        {text: 'Other', value: 'Other'}
      ],
      Reason: null,
      approveModal: false
    }
  },
  methods: {
    showModal() {
      if (this.$showApprove([3, 4, 5, 11, 12])) {
        this.approveModal = true
      } else {
        this.modal = true
        this.Reason = null
      }
      if (this.CreateOrderMode){
        this.model = true
      }
    },
    openWithAcceptPermission() {
      this.approveModal = false
      this.modal = true
      this.Reason = null
    },
    calcCreditByPercent(percent) {
      this.orderCredit = ((percent * this.Subtotal) / 100).toFixed(2)
    },
    show() {
      this.orderCredit = ''
    },
    addCredit() {
      // if (!this.enableCredit) {
      //     this.enableCredit = !this.enableCredit
      // } else {
      //
      // }
      this.$validator.validateAll().then(res => {
        if (res) {
          const model = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            // UserID: localStorage.getItem('userID'),
            OrderID: this.orderId,
            Credit: this.orderCredit,
            Reason: this.Reason
          }
          this.loading = true
          this.$api.getRestaurant
            .UpdateOrderCredit(model)
            .then(res => {
              if (res.success) {
                this.loading = false
                this.modal = false
                this.$emit('updateCredit')
              } else {
                this.loadingBtn = false
                this.$showError(res.message)
              }
            })
            .catch(() => {
              this.loadingBtn = false
            })
          // const model = {
          //     Credit: this.updateCredit,
          //     Reason: this.Reason
          // }
        }
      })
    }
  }
}
</script>

<style scoped>
.form-control:disabled,
.form-control[readonly] {
  background: #fff !important;
}
.removeBorder {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
}
.percent {
  border: 1px solid rgba(176, 176, 176, 0.82);
}
.percent li {
  display: inline-block;
  list-style: none;
  width: 20%;
  text-align: center;
  border-right: 1px solid rgba(176, 176, 176, 0.82);
}
.percent li:hover {
  background: #e0b700;
}
.percent li:last-child {
  border-right: none;
}
</style>
